import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const deleteToteGroup = {
  name: "deleteToteGroup" as const,
  input: z.object({ toteGroupId: zExt.objectId() }),
  output: z.object({ success: z.boolean() }),
};
